import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #FFFFFF;
  color: #323467;
`;